type CallFocusCheckboxesProps = {
  formikProps?: Record<string, unknown>;
  isDisabled?: boolean;
  onChange?: (
    options: Record<string, boolean>,
    key: string,
    formikProps: Record<string, unknown>,
  ) => void;
  options: Record<string, boolean>;
};

export function CallFocusCheckboxes({
  formikProps = {},
  isDisabled = false,
  onChange,
  options,
}: CallFocusCheckboxesProps) {
  return (
    <>
      {Object.entries(options)
        .sort()
        .map(([optionKey, optionValue]) => (
          <div className="custom-control custom-checkbox col-12 col-lg-4" key={optionKey}>
            <input
              checked={Boolean(optionValue)}
              className="custom-control-input"
              disabled={isDisabled || undefined}
              id={optionKey}
              name={optionKey}
              onClick={() => onChange?.(options, optionKey, formikProps)}
              type="checkbox"
            />

            <label className="custom-control-label" htmlFor={optionKey}>
              <span>{optionKey}</span>
            </label>
          </div>
        ))}
    </>
  );
}
